<section class="features-grid">

    <div class="container-redesign">

        <div class="features-grid__heading">

            <h2 class="features-grid__title">
                From reactive mental healthcare to
                <span>proactive prevention</span>
            </h2>

            <p class="features-grid__description">
                The difference isn’t more data, it’s knowing what matters early enough to act,
                especially in mental health conditions where subtle changes often appear long
                before a crisis.
            </p>

        </div>

        <div class="features-grid__cards">

            <article
    class="features-grid__card"
    *ngFor="let feature of features; trackBy: trackByTitle">

    <div class="features-grid__icon">

        <img
            [src]="'/assets/img/redesign/' + feature.icon"
            [alt]="feature.title">

    </div>

    <h3>{{ feature.title }}</h3>

    <p>{{ feature.description }}</p>

</article>

        </div>

    </div>

</section>